import {
  Alert,
  Box,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material';
import { Trash01, Plus } from '../../../assets';
import { useContext } from 'react';
import { StockCountZonesContext, StockCountZonesContextValues } from '../contexts/StockCountZonesContext';

const StockCountZonesCreateCategories = () => {
  const {
    t,
    isLoading,
    categoryData,
    deleteCategoryRow,
    handleAddCategoriesClick,
  } = useContext(StockCountZonesContext) as StockCountZonesContextValues;

  const theme = useTheme();
  const hasCategories = categoryData.length > 0;

  if (isLoading) {
    return <></>;
  }

  return (
    <Box sx={{ border: '2px solid', borderRadius: '4px', borderColor: theme.palette.primary[500] }}>
      <Grid container
        sx={{ pt: '12px', pb: '6px', px: '8px' }}>
        <Grid item
          xs={6}>
          <Typography variant="textMD"
            fontWeight="bold">
            {t('categories.title')}
          </Typography>
        </Grid>
        <Grid item
          xs={6}
          sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          {hasCategories && (
            <Button
              size="lg"
              sx={{ mr: 4 }}
              variant="bad"
              onClick={() => deleteCategoryRow()} >
              <Trash01 />
              {t('categories.deleteAll')}
            </Button>
          )}
          <Button
            size="lg"
            variant="primary"
            onClick={handleAddCategoriesClick}>
            <Plus />
            {t('categories.add')}
          </Button>
        </Grid>
      </Grid>

      <Box sx={{ pt: 1 }}>
        {hasCategories ? (
          <TableContainer
            sx={
              categoryData.length > 10
                ? { maxHeight: 400, overflowY: 'auto' }
                : undefined
            }
          >
            <Table stickyHeader={categoryData.length > 10}>
              <TableHead>
                <TableRow>
                  <TableCell>{t('categories.name')}</TableCell>
                  <TableCell align="right">{t('categories.actions')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {categoryData.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell>{row.primaryCategoryName}</TableCell>
                    <TableCell align="right">
                      <Trash01
                        style={{ color: 'red', cursor: 'pointer' }}
                        onClick={() => deleteCategoryRow?.(row.id)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Alert
            severity="info"
            variant="outlined"
            sx={{ mb: '12px', mx: '8px' }}
          >
            {t('categories.noCategories')}
          </Alert>
        )}
      </Box>
    </Box>
  );
};

export default StockCountZonesCreateCategories;